//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContactSupportForm from '@/components/forms/ContactSupportForm.vue';
export default {
  components: { ContactSupportForm },
  head: {
    title: 'Contact Support | BOMIST',
    meta: [
      {
        name: 'robots',
        content: 'noindex,nofollow,noarchive'
      }
    ]
  }
};
